import axios from "axios";


export const getAncillaryConfig = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobsancillary/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editAncillaryConfig = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobsancillary/editancillaryconfiguration",
      data
    )
    .then((res) => res.data);
};
